import { formatFileSize } from "@/lib/formatFileSize";

const plural = (n: number, one: string, many = `${one}s`) => `${n} ${n === 1 ? one : many}`;

/** The line above the file list: "4 files · 11 pages — drag to reorder".
 * pageCount covers only the files that will actually be merged, and is
 * left out until every file has finished being checked (a partial total
 * that then jumps would read as a bug). */
export function formatSelectionSummary(opts: {
  fileCount: number;
  pageCount: number;
  pendingCount: number;
  unreadableCount: number;
}): string {
  const { fileCount, pageCount, pendingCount, unreadableCount } = opts;
  let text = plural(fileCount, "file");
  if (pendingCount === 0 && pageCount > 0) text += ` · ${plural(pageCount, "page")}`;
  text += " — drag to reorder";
  if (unreadableCount > 0) text += ` (${unreadableCount} can't be merged — see below)`;
  return text;
}

/** The line above the Download button: "11 pages · 1.12 MB". */
export function formatMergedSummary(pageCount: number, bytes: number): string {
  return `${plural(pageCount, "page")} · ${formatFileSize(bytes)}`;
}
